"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilterByPath = void 0;
const types_1 = require("./types");
const getFilterByPath = (filter, path) => {
    let target = filter;
    path.forEach(pathElement => {
        let newTarget = [];
        if (target && (0, types_1.isAndFilter)(target)) {
            newTarget = target.and;
        }
        else if (target && (0, types_1.isOrFilter)(target)) {
            newTarget = target.or;
        }
        else if (target) {
            throw new Error('Incorrect path, Binary and Unary fiter can not be the part of the path');
        }
        target = newTarget[pathElement];
    });
    return target;
};
exports.getFilterByPath = getFilterByPath;
//# sourceMappingURL=getFilterByPath.js.map